import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import noop from 'lodash.noop'
import { AddToWishlist, ErrorBoundary, HeaderFetcher } from '@sainsburys-tech/bolt'
import { canUseDom } from '@sainsburys-tech/boltui-utils'
import { updateUserInfo } from '../../helpers/taggingSerializer'
import { fulfilmentPassUserLoaded } from '../../actionCreators/fulfilmentPass/fulfilmentPassActionCreators'

const USER_STATE_GUEST = 'GUEST'
class Header extends Component {
  onUserInfoLoad = userInfo => {
    this.setState(userInfo)
    updateUserInfo(userInfo)
    const isLoggedInUser = userInfo?.userId && userInfo?.userState !== USER_STATE_GUEST
    const loggedInUserId = isLoggedInUser ? userInfo.userId : ''
    this.props.fulfilmentPassUserLoaded(loggedInUserId)
    this.props.getUserDetails()
    return {}
  }

  shouldOverrideMegaNavLocation = () => {
    if (!canUseDom()) {
      return null
    }
    if (window.location.hostname.toLowerCase().indexOf('wc7st1.argos.co.uk') !== -1)
      return 'https://www.argos.co.uk/homepage-assets/static/json/TuSIT2header.json'
    return null
  }

  buildOptions() {
    const { onUserInfoLoad } = this
    const trolleyCountChange = this.props.trolleyCount

    const overrideWishlistCount = this.props.wishlistCount
    const overrideMegaNavLocation = this.shouldOverrideMegaNavLocation()
    const skipToContentTag = '#content'
    const options = {
      onUserInfoLoad,
      trolleyCountChange,
      overrideWishlistCount,
      overrideMegaNavLocation,
      skipToContentTag
    }
    return options
  }

  render = () => {
    const options = this.buildOptions()
    return (
      <ErrorBoundary retry={2}>
        <div>
          <HeaderFetcher.ArgosHeader {...options} />
        </div>
      </ErrorBoundary>
    )
  }
}

Header.propTypes = {
  getUserDetails: PropTypes.func,
  fulfilmentPassUserLoaded: PropTypes.func
}

Header.defaultProps = {
  getUserDetails: noop,
  fulfilmentPassUserLoaded: noop
}

const mapStateToProps = state => ({
  trolleyCount: (state.trolleyItems && state.trolleyItems.total) || 0,
  wishlistCount: AddToWishlist.getWishlistCount(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getUserDetails: AddToWishlist.getUserDetails,
      fulfilmentPassUserLoaded
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Header)
export { Header, mapStateToProps }
